<template>
  <div class="animated fadeIn">
    <basic-heading title="Prep Processes" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list prep process'">
      <template #gated-content>
        <prep-process-server-table @deletePrepProcess="deletePrepProcess" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import PrepProcessServerTable from "@/components/lab/prepprocess/PrepProcessServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { prepProcessNotifications } from "@/shared/notifications";

Vue.use(VueNotifications, notificationOptions);

const PrepProcessRepository = LabRepositoryFactory.get("prepProcess");

export default {
  name: "PrepProcessIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    PrepProcessServerTable,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/prep-processes/add",
            title: "Add prep process",
            variant: "success",
            permission: this.checkPermission("add prep process"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    async deletePrepProcess(id, ref) {
      try {
        await PrepProcessRepository.suspend(id);

        this.deleteSuccess();

        ref.refresh();
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Prep Process delete Failed.",
          variant: "danger",
        });
      }
    },
  },
  notifications: prepProcessNotifications,
};
</script>
